import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";
import { OrderProgressModeActions } from "@dana/Store/Data/OrderProgressLoading/Reducers/OrderProgressLoadingReducer";

type HandlerType = ApiHandler<{isOn:boolean},
    DispatchProp<OrderProgressModeActions>
>;

export const SetOrderProgressMode: HandlerType = props => {

    props.dispatch({
        type: "OrderProgressMode/IsOn",
        isOn: props.parameter.isOn,
    } as any);
};

export const chain = [SetOrderProgressMode];

const setOrderProgressMode = createHandlerChainRunner(chain, "SetOrderProgressMode");
export default setOrderProgressMode;